export default "__VITE_ASSET__DLz3xU_Z__"